import { render, staticRenderFns } from "./EmptyNotesComponent.vue?vue&type=template&id=3d031709&scoped=true"
import script from "./EmptyNotesComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./EmptyNotesComponent.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./EmptyNotesComponent.vue?vue&type=style&index=0&id=3d031709&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d031709",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d031709')) {
      api.createRecord('3d031709', component.options)
    } else {
      api.reload('3d031709', component.options)
    }
    module.hot.accept("./EmptyNotesComponent.vue?vue&type=template&id=3d031709&scoped=true", function () {
      api.rerender('3d031709', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/widgets/ExpedientWidgets/ExpedientReminderNotes/EmptyNotesComponent.vue"
export default component.exports